import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Editor, { TABLE_CELL_COMPONENT, FORM_FIELD_COMPONENT, NOT_APPLICABLE } from '../Editor';
import './EnumEditor.scss';

class EnumComponent extends React.PureComponent {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    id: PropTypes.string,
    editing: PropTypes.bool,
    label: PropTypes.string,
    description: PropTypes.string,
    error: PropTypes.string,
    readOnly: PropTypes.bool,
    type: PropTypes.string.isRequired,
    schemaService: PropTypes.shape({
      getType: PropTypes.func.isRequired,
      getEnumNamedValues: PropTypes.func.isRequired,
    }).isRequired,
    property: PropTypes.shape({
      enumValues: PropTypes.arrayOf(PropTypes.shape({})),
      margin: PropTypes.string,
    }),
    form: PropTypes.bool,
  }

  static defaultProps = {
    id: undefined,
    editing: false,
    error: null,
    readOnly: false,
    label: null,
    description: null,
    form: false,
    property: undefined,
    value: undefined,
  };

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (event) => {
    const { onChange } = this.props;
    if (onChange) {
      onChange(event.target.value);
    }
  };

  render() {
    const {
      id,
      value,
      editing,
      error,
      label,
      description,
      readOnly,
      schemaService,
      form,
      property,
    } = this.props;
    const typename = this.props.type;
    const type = schemaService.getType(typename);
    const values = (property && property.enumValues) || schemaService.getEnumNamedValues(type);
    const getEnumDescription = (v) => {
      const node = values.find(n => n.value === v);
      return node && node.description || NOT_APPLICABLE;
    };
    const margin = property && property.margin || (form ? 'normal' : 'dense');
    return (
      <div className={classnames('tuc-enum-editor', form && 'tuc-editor-form')}>
        {editing && !readOnly && (
          <TextField
            select
            label={label}
            value={value}
            onChange={this.handleChange}
            error={Boolean(error)}
            helperText={error || description}
            margin={margin}
          >
            {values && values.map((node => (
              <MenuItem value={node.value} key={JSON.stringify(node.value)} className="tuc-select-menuitem">{node.description}</MenuItem>
            )))}
          </TextField>
        )}
        {(!editing || readOnly) && (
          form ? (
            <TextField
              id={id}
              label={label}
              value={getEnumDescription(value)}
              margin="normal"
              InputProps={{
                readOnly: true,
              }}
              helperText={description || type.description}
            />
           ) : (
             <Typography>
               {getEnumDescription(value)}
             </Typography>
           )
        )}
      </div>
    );
  }
}

export default class EnumEditor extends Editor {
  constructor(schemaService, name, components) {
    super(name || 'enum', Object.assign({}, {
      [TABLE_CELL_COMPONENT]: [EnumComponent],
      [FORM_FIELD_COMPONENT]: [EnumComponent],
    }, components));
    this.schemaService = schemaService;
  }

  getSortValue(value, formattedValue) {
    return formattedValue;
  }

  formatValue(value, data, propName, props = {}) {
    const { type: typename, enumValues } = props;
    const type = this.schemaService.getType(typename);
    const values = enumValues || this.schemaService.getEnumNamedValues(type);
    const getEnumDescription = (v) => {
      const node = values.find(n => n.value === v);
      return node && node.description || NOT_APPLICABLE;
    };
    return getEnumDescription(value);
  }
}
